module.exports = __webpack_public_path__ + "static/TABLERO DE CONTROL-46d17b6240f5e832823aa37dc556c859.webp";